(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('pingTreeService', pingTreeService);

  function pingTreeService(
    $http,
    concurrencyMatrixService,
    ngAuthSettings,
    statsService,
    pingTreeTargetService
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const columnSettings = {
      name: {
        class: 'column-sortable text-left',
        stSort: 'name',
        stSkipNatural: true,
        displayName: 'PING_TREES_NAME'
      },
      minRevenueToRoute: {
        class: 'column-sortable text-right',
        stSort: 'minRevenueToRoute || 0',
        stSkipNatural: true,
        displayName: 'PING_TREES_MIN_REVENUE_TO_ROUTE',
        rowAlign: 'right'
      },
      revenueDynamic: {
        class: 'column-sortable text-left',
        stSort: 'revenueSettings.revenueDynamic || false',
        stSkipNatural: true,
        displayName: 'PING_TREES_REVENUE_DYNAMIC_TO_ROUTE'
      },
      revenueOnFailure: {
        class: 'column-sortable text-right',
        stSort: 'revenueSettings.revenueOnFailure || 0',
        stSkipNatural: true,
        displayName: 'PING_TREES_REVENUE_ON_FAILURE',
        rowAlign: 'right'
      },
      numTargets: {
        class: 'column-sortable text-right',
        stSort: 'targets.length || 0',
        displayName: 'PING_TREES_TARGETS',
        stSkipNatural: true,
        rowAlign: 'right'
      },
      enabled: {
        class: 'tablesort-sortable text-center',
        stSort: 'enabled',
        displayName: 'PING_TREES_STATUS',
        rowAlign: 'center'
      }
    };

    const defaultColumns = [
      'name',
      'revenueDynamic',
      'minRevenueToRoute',
      'revenueOnFailure',
      'numTargets',
      'enabled'
    ];

    const service = {
      createPingTree: createPingTree,
      deletePingTree: deletePingTree,
      getPingTree: getPingTree,
      getPingTrees: getPingTrees,
      updatePingTree: updatePingTree,
      updatePingTreeProperty: updatePingTreeProperty,
      removeTarget: removeTarget,
      updateTargets: updateTargets,
      addTarget: addTarget,
      resetCallCounters: resetCallCounters,
      defaultColumns: defaultColumns,
      columnSettings: columnSettings,
      getPingTreeReferences: getPingTreeReferences
    };
    return service;

    function getPingTrees(accountId, getStats, updateStatsObj) {
      const url = serviceBaseUri + accountId + '/pingtrees';
      let params = {};
      if (getStats) {
        params = { includeStats: true };
      }
      return $http({
        url: url,
        method: 'GET',
        params: params
      }).then(function handlePingTreeResponse(response) {
        let pingTrees;
        if (updateStatsObj) {
          pingTrees = updateStatsObj.pingTrees;
        } else {
          pingTrees = response.data.pingTrees;
        }
     
        if (getStats) {
          statsService.normalizeStats(pingTrees, response.data.stats, response.data.caps, pingTreeTargetService.blockReasonTranslation);
        }

        response.data.pingTrees = pingTrees;
        return response;        
      });
    }

    function getPingTree(accountId, pingTreeId) {
      const url = _serviceBaseUrl(accountId, pingTreeId);
      return $http.get(url).then(_transformConcurrencyMatrixFromResponse);
    }

    function createPingTree(accountId, pingTree) {
      const data = _sanitizePingTree(pingTree);
      const url = serviceBaseUri + accountId + '/pingtrees';
      return $http.post(url, data).then(_transformConcurrencyMatrixFromResponse);
    }

    function deletePingTree(accountId, pingTreeId, force) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '?force=' + !!force;
      return $http.delete(url);
    }

    function updatePingTree(accountId, pingTree) {
      const data = _sanitizePingTree(pingTree);
      const url = _serviceBaseUrl(accountId, pingTree.id);
      return $http.patch(url, data).then(_transformConcurrencyMatrixFromResponse);
    }

    function updatePingTreeProperty(accountId, pingTreeId, item) {
      const url = _serviceBaseUrl(accountId, pingTreeId);
      return $http.patch(url, item);
    }

    function addTarget(accountId, pingTreeId, targetId) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '/targets';
      const data = { targetId: targetId };
      return $http.patch(url, data);
    }

    function removeTarget(accountId, pingTreeId, targetId) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '/targets/' + targetId;
      return $http.delete(url);
    }

    function updateTargets(accountId, pingTreeId, addtargets, removeTargets) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '/targets/bulkUpdate';
      const data = {
        targetAddIds: addtargets,
        targetRemoveIds: removeTargets
      };
      return $http.patch(url, data);
    }

    function resetCallCounters(accountId, pingTreeId) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '/resetcount';
      return $http.delete(url);
    }

    function getPingTreeReferences(accountId, pingTreeId) {
      const url = _serviceBaseUrl(accountId, pingTreeId) + '/InboundReferences';
      return $http.get(url);
    }

    function _serviceBaseUrl(accountId, pingTreeId) {
      return serviceBaseUri + accountId + '/pingtrees/' + pingTreeId;
    }

    function _sanitizePingTree(pingTree) {
      const sanitized = { id: pingTree.id };

      if (Object.hasOwn(pingTree, 'name')) { sanitized.name = pingTree.name; }
      if (Object.hasOwn(pingTree, 'conversionTimerOffset')) { sanitized.conversionTimerOffset = pingTree.conversionTimerOffset; }
      if (Object.hasOwn(pingTree, 'enabled')) { sanitized.enabled = pingTree.enabled; }
      if (Object.hasOwn(pingTree, 'isSimalDial')) { sanitized.isSimalDial = pingTree.isSimalDial; }
      if (Object.hasOwn(pingTree, 'schedule')) { sanitized.schedule = angular.copy(pingTree.schedule); }
      if (Object.hasOwn(pingTree, 'revenueSettings')) { sanitized.revenueSettings = angular.copy(pingTree.revenueSettings); }
      if (Object.hasOwn(pingTree, 'errorSettings')) { sanitized.errorSettings = angular.copy(pingTree.errorSettings); }
      if (Object.hasOwn(pingTree, 'minRevenueToRoute')) { sanitized.minRevenueToRoute = pingTree.minRevenueToRoute; }
      if (typeof pingTree.schedule !== 'undefined' && pingTree.schedule.callConcurrencyMatrix) {
        sanitized.schedule.callConcurrencyMatrix = concurrencyMatrixService.postProcessMatrix(sanitized.schedule.callConcurrencyMatrix);
      }
      return sanitized;
    }

    function _transformConcurrencyMatrixFromResponse(response){
      const pingTree = response.data.pingTree;

      if (typeof pingTree.schedule !== 'undefined' && pingTree.schedule.callConcurrencyMatrix) {
        pingTree.schedule.callConcurrencyMatrix = concurrencyMatrixService.getProcessMatrix(pingTree.schedule.callConcurrencyMatrix);
      }

      return pingTree;
    }
  }
})();
